import { useTranslation } from 'react-i18next';
import { colors, screen, fonts } from 'components/styles/variables';
import classNames from 'classnames';
import { LocationDisplayProps } from './types';
import Delivery from './Delivery';
import Map from './Map';

export default function LocationDisplay({
  address,
  city,
  state,
  zip,
  imageUrl,
  mapUrl,
  className,
  transferAvailable,
  isRegional,
}: LocationDisplayProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <figure className={classNames('location', className)}>
      {transferAvailable && <div className="transfer-available">{t('vdp.transferAvailable')}</div>}
      {isRegional ? (
        <Delivery />
      ) : (
        <Map
          address={address}
          city={city}
          state={state}
          zip={zip}
          imageUrl={imageUrl}
          mapUrl={mapUrl}
        />
      )}

      <style jsx>
        {`
          .location {
            margin: 0;
            display: flex;
            flex-direction: column;
            position: relative;
            border: 1px solid ${colors.G2};
            color: ${colors.BLACK};
            overflow: hidden;
            box-sizing: border-box;
            border-radius: 16px;
            background: white;
            font-family: ${fonts.default};
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 22px;
          }

          @media screen and (min-width: ${screen.smMin}) {
            .location {
              width: 375px;
              height: 240px;
            }
          }

          .transfer-available {
            display: flex;
            align-items: center;
            position: absolute;
            top: 16px;
            left: 16px;
            height: 30px;
            padding: 0px 8px;
            background: ${colors.ALB1};
            text-transform: uppercase;
            font-size: 14px;
            font-weight: 600;
            color: ${colors.WHITE};
            border-radius: 4px;
          }
        `}
      </style>
    </figure>
  );
}
